<template>
  <v-layout row class="mb-3">
    <v-flex v-if="!hideBackBtn">
      <BackBtn class="pb-2" />
    </v-flex>

    <v-flex align-self-center xs12 sm4 :class="{ 'offset-sm8': hideBackBtn }">
      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        @input="setValue()"
        data-cy="searchBar"
        label="Search"
        :append-icon="`${search ? 'mdi-close' : ''}`"
        @click:append="setNull()"
        single-line
        solo
        flat
        hide-details
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ["hideBackBtn"],
  data() {
    return {
      search: null,
    };
  },
  methods: {
    setValue() {
      this.$emit("input", this.search);
    },
    setNull() {
      this.$emit("input", "");
      this.search = "";
    },
  },
};
</script>

<style scoped>
</style>
